export default __webpack_public_path__ + "static/media/IBMSecurity.656d0d74.svg";